import { connection } from "./portal.config";


var _globalHistory;

export function setGlobalHistory(history) {
    _globalHistory = history;
}

export function navigate(path) {
    _globalHistory.push(path);
}

export const portalCfg = {
    basename: connection.crmConfig.basename,
    publicPath: connection.crmConfig.publicPath
}
export const paths = {
    landingPage:'/landing-page',
    login: '/login',
    register: '/register',
    home:'/home',
    offers:'/offers',
    orders:'/orders',
    myProfile:'/my-profile',
    moreInfo: '/more-info',
    referFriend: '/refer-friend',
    notifications: '/notifications',
    termConditions: '/term-conditions',
    privacyPolicy: '/privacy-policy',
    forgotPassword: '/forgot-password',
    identify: '/identify',
    map: '/map',
    addressBook: '/addresses',
    topup_wallet: '/topup-wallet',
    process_order:'/process_order',
    process_topup:'/process_topup',
    process_addcard:'/process_addcard',
    service_requests: '/service-requests',
    redeem_pass: '/redeem_pass',
    subcriptions: '/subcriptions',
    online_shop: '/online-shop',
    mobile_pass_card: 'mobile-pass-card',
    invoice: '/invoice',
    wallet: '/wallet',
    paymaya_redirect_url_success: '/paymaya/checkout_success',
    paymaya_redirect_url_failure: '/paymaya/checkout_failure',
    paymaya_redirect_url_dropout: '/paymaya/checkout_dropout',
    vnpay_order: '/vnpay/order',
    fac_result: '/fac_result',
    register_existing: '/register-existing',
    process_payment: '/process-payment',
    new_process_topup: '/process-topup'
}
/**
 * route permission configuration
 * <path> : [scope, access list of <indicator|merchant type|group> : <read write permission>
 * - path: use predefined path
 * - scope: 
 *      + _IN_SESSION - only use if a session exists
 *      + _IN_OUT_SESSION  - can be used without a session
 *      + _OUT_SESSION - only used without a session - usedWithSession will be ignored
 * - access list:
 *      + < indicator|merchant type|group > -> if a user profile does not have its combination exist -> no access at all
 *      + read write permission: r - read, w - write, e.g. rw. 
 *      + indicator value: A - aggregated, M - master merchant, T - third party agent
 *      + merchant type (when indicator = M): H - HQ, S - Sub merchant, M - master merchant (agent), HS - HQ and sub merchant
 *      + group: ADMIN, TEAMMGR, AGENT, USR, MANAGER = MGR ?
 * 
 * NOTE: Read/Write permission is acting so far only as a reference. To show/hide a button use actions configuration
 */

const _IN_SESSION = 0;
const _OUT_SESSION = 2;
const _IN_OUT_SESSION = 3;

export const SCOPE = {
    _IN_SESSION,
    _OUT_SESSION,
    _IN_OUT_SESSION
}
export const routeACL = {
    [paths.landingPage]: _OUT_SESSION,
    [paths.login]: _OUT_SESSION,
    [paths.register]: _OUT_SESSION,
    [paths.forgotPassword]: _OUT_SESSION,
    [paths.home]: _IN_SESSION,
    [paths.offers]: _IN_SESSION,
    [paths.orders]: _IN_SESSION,
    [paths.spendPreferences]: _IN_SESSION,
    [paths.merchants]: _IN_SESSION,
    [paths.myProfile]: _IN_SESSION,
    [paths.moreInfo]: _IN_SESSION,
    [paths.referFriend]: _IN_SESSION,
    [paths.notifications]: _IN_SESSION,
    [paths.identify]: _IN_SESSION,
    [paths.map]: _IN_SESSION,
    [paths.addressBook]: _IN_SESSION,
    [paths.topup_wallet]: _IN_SESSION,
    [paths.service_requests]: _IN_SESSION,
    [paths.redeem_pass]: _IN_SESSION,
}


